import styled from "styled-components";

export const Container = styled.aside`
  position: fixed;
  height: 100vh;
  width: 100%;
  z-index: 3;
  margin: auto;
  right: 0;
  background-color: ${(props) => props.theme.colors.typography3.pure};
  color: ${(props) => props.theme.colors.typography1.pure};

  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: max-content;
    padding: 0 24px;
  }

  @media (min-width: 1024px) {
    padding: 0 104px;
  }
`;

export const AsideHeader = styled.header`
  padding: 22px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 1.1rem;

  @media (min-width: 768px) {
    padding: 18px;
    font-size: 1rem;
    display: none;
  }

  > h3 {
    font-weight: normal;
  }

  > svg {
    width: 16px;
    height: 16px;
    cursor: pointer;

    @media (min-width: 768px) {
      width: 16px;
      height: 16px;
    }
  }
`;

export const AsideMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    position: absolute;
    top: 57px;
    background-color: ${(props) => props.theme.colors.brand4.dark};
  }

  .title {
    display: none;
  }

  .informations {
    background-color: ${(props) => props.theme.colors.brand4.pure};
    width: 92%;
    border-radius: 16px;
    padding: 18px 24px;
    display: flex;

    @media (min-width: 768px) {
      margin-top: 15px;
      border-radius: 8px;
      padding: 8px 14px;
    }
  }

  .svg__user {
    margin-top: 5px;
    width: 20px;
    height: 20px;
    @media (min-width: 768px) {
      width: 16px;
      height: 16px;
    }
  }

  .brands_aside-menu {
    height: min-content;
    background-color: transparent;
    position: relative;
    align-items: flex-start;
    margin-left: 30px;
    gap: 0;
    margin: auto;
    padding: 12px 0 70px 0;

    @media (max-height: 568px) {
      padding: 5px 0 10px 0;
    }

    @media (min-width: 768px) {
      width: 250px;
      padding: 12px 0 40px 0;
    }

    div {
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
    }

    button {
      flex-direction: row;
      width: max-content;
    }

    img {
      width: 50px;
      height: 50px;

      @media (min-width: 768px) {
        width: 35px;
        height: 35px;
      }
    }

    label {
      @media (min-width: 768px) {
        padding: 0;
      }

      &::after {
        content: none;
      }
    }
  }

  > button {
    padding: 16px 0;
    background-color: transparent;
    width: 40%;
    border: none;
    color: ${(props) => props.theme.colors.typography1.pure};
    font-size: 1rem;

    @media (min-width: 768px) {
      width: 60%;
      font-size: 0.83rem;
      border-top: 1px solid ${(props) => props.theme.colors.typography1.pure};
    }

    &::after {
      content: "Sair";
    }
  }
`;

export const UserInformations = styled.div`
  padding-left: 16px;

  > h4, span {
    font-weight: normal;
    }

  > h4 {
    font-size: 0.8rem;
    margin-bottom: 4px;

    @media (min-width: 768px) {
      font-size: 0.7rem;
    }
  }

  > span {
    font-size: 0.6rem;
    line-height: 22px;

    @media (min-width: 768px) {
      line-height: 8px;
    }
  }
`;
